import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import OrderItem from '../OrderItems/';
import {
  getOrderStatusColor,
  formatAddress,
  formatPrice,
} from '../../utils/helpers';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  FormLabel,
  FormControl,
  Select,
} from '@chakra-ui/react';
import axios from 'axios';
import { useOrderContext } from '../../context/order_context';

const OrderContent = ({
  paymentInfo,
  orderItems,
  totalPrice,
  orderStatus,
  user: { name },
  shippingInfo,
  shippingPrice,
  id,
  paymentStatus
}) => {
  const { refetchOrders, orders, couponDiscount } = useOrderContext();
  const [reason, setReason] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [buttonStatus, setButtonStatus] = useState(null);
  const [refundStatus, setRefundStatus] = useState('');
  const [showMore, setShowMore] = useState(false);

  let cancelButtonText = '';
  switch (orderStatus) {
    case 'delivered':
      cancelButtonText = 'Return Order';
      break;
    case 'CANCELED':
      cancelButtonText = 'Cancelled';
      break;
    case 'cancelled':
      cancelButtonText = 'Cancelled';
      break;
    case 'returned':
      cancelButtonText = orderStatus;
      break;
    case 'rejected':
      cancelButtonText = 'Rejected';
      break;
    default:
      cancelButtonText = 'Cancel Order';
  }

  useEffect(() => {
    if (orderStatus === 'delivered') {
      setButtonStatus(null);
    } else if (
      orderStatus === 'cancelled' ||
      orderStatus === 'returned' ||
      orderStatus === 'rejected' ||
      orderStatus === 'Refund Rejected' ||
      orderStatus === 'initiate refund' ||
      orderStatus === 'CANCELED'
    ) {
      setButtonStatus('disabled');
    }
  }, [orderStatus]);

  useEffect(() => {
    if (orderStatus === 'initiate refund') {
      async function fetchRefundStatus() {
        try {
          const refundResponse = await axios.get(
            `${process.env.REACT_APP_BACKEND_HOST}/api/payment/refund/${paymentInfo.refundId}`
          );
          setRefundStatus(refundResponse.data.status);
        } catch (error) {
          console.error('Error:', error);
        }
      }
      fetchRefundStatus();
    }
  }, [orderStatus, paymentInfo.refundId]);

  const displayedStatus =
    refundStatus === 'processed' || refundStatus === 'processing'
      ? `Refund ${refundStatus}`
      : orderStatus;

  const handleSubmit = () => {
    if (reason.length > 1) {
      let status = orderStatus === 'delivered' ? 'return' : 'cancel';
      axios
        .put(
          `${process.env.REACT_APP_BACKEND_HOST}/api/admin/order/status/${id}`,
          { status: status, reason: reason }
        )
        .then((response) => {
          onClose();
          refetchOrders();
        })
        .catch((error) => {
          console.error('Error:', error);
          onClose();
        });
    } else {
    }
  };
  let originalPrice = 0;
  orderItems.map(
    (e) => (originalPrice += Number(e.price) * Number(e.quantity))
  );
  return (
    <Wrapper className='section section-center'>
       {orderItems.map((item) => {
        return (
          <OrderItem
            key={item._id + item.color}
            orderStatus={orderStatus}
            paymentStatus={paymentStatus}
            {...item}
            shippingInfo={shippingInfo}
          />
        );
      })}

      <div className='button-container md:justify-end justify-center'>
        {buttonStatus ? (
          <button
            className='cancel-buton'
            disabled
            onClick={onOpen}
            style={{ backgroundColor: '#010535', color: 'white' }}
          >
            {cancelButtonText}
          </button>
        ) : (
          <button
            className='cancel-buton'
            onClick={onOpen}
            style={{ backgroundColor: '#010535', color: 'white' }}
          >
            {cancelButtonText}
          </button>
        )}
      </div>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Mukunda Jewelery</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {orderStatus === 'delivered' ? (
              <FormControl>
                <FormLabel>
                  Please select the reason for {cancelButtonText}
                </FormLabel>
                <Select
                  placeholder='Select option'
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value='Damaged Products'>Damaged Products</option>
                  <option value='Not satisfied'>Not satisfied</option>
                  <option value='Different Product received'>
                    Different Product received
                  </option>
                  <option value='Wrong Size/Color'>Wrong Size/Color</option>
                  <option value='Defective Product'>Defective Product</option>
                </Select>
              </FormControl>
            ) : (
              <FormControl>
                <FormLabel>
                  Please select the reason for {cancelButtonText}
                </FormLabel>
                <Select
                  placeholder='Select option'
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value='Taking more time than usual'>
                    Taking more time than usual
                  </option>
                  <option value='Found a better deal'>
                    Found a better deal
                  </option>
                  <option value='Wrong Address Mentioned'>
                    Wrong Address Mentioned
                  </option>
                  <option value='Changed mind'>Changed mind</option>
                  <option value='Ordered by mistake'>Ordered by mistake</option>
                </Select>
              </FormControl>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={onClose}>
              Close
            </Button>
            <Button onClick={handleSubmit}>Submit</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Wrapper>
  );
};

export default OrderContent;
